
import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';


@Injectable()
export class HRBPDataService
{
    private readonly APIEndPoint: any = environment.apiEndPoint;
    private actionUrl: string = this.APIEndPoint + "/api/";
    private headers: Headers;
    private apiUrl: string;

    constructor(private http: Http, private authHttp: AuthHttp) {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');
        this.headers.append("Access-Control-Allow-Origin", "*");
    }

    getHRBPDetails() {
        this.apiUrl = this.APIEndPoint + '/api/HRBusinessParter/getDetails';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }
    getHRBPDetailsByID(id:any) {
        this.apiUrl = this.APIEndPoint + '/api/HRBusinessParter/GetDetailsByID/'+id;
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }
    saveDetail(hrbpDetail: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(hrbpDetail);
        return this.authHttp.post(this.APIEndPoint + '/api/HRBusinessParter/SaveDetail', hrbpDetail, options).map(res => {
            return res.json();
        });
    }
    deleteDetail(id: number) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.delete(this.APIEndPoint + '/api/HRBusinessParter/Delete/'+id, options).map(res => {
            return res.json();
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/Services/hrbp.service.ts